<div class="w100">
    <p *ngFor="let pa of data">
    {{ pa }}
    </p>
</div>